const AppCenterLayout = () => import(/* webpackChunkName: "appcenter" */ '@/components/appCenter/AppCenterLayout')
const AllAppPage = () => import(/* webpackChunkName: "appcenter" */'@/components/appCenter/AllApp')
const PosterList = () => import(/* webpackChunkName: "appcenter" */'@/components/appCenter/PosterList')
const PayIcon = () => import(/* webpackChunkName: "appcenter" */'@/components/appCenter/PayIcon')
const HotIntroduce = () => import(/* webpackChunkName: "appcenter" */'@/components/appCenter/HotIntroduce')
const PropagandaPoster = () => import(/* webpackChunkName: "appcenter" */'@/components/appCenter/PropagandaPoster')
const SpikePosterList = () => import(/* webpackChunkName: "appcenter" */'@/components/appCenter/SpikePosterList')
const HotRecommendNav = () => import(/* webpackChunkName: "appcenter" */'@/components/appCenter/HotRecommendNav')
const HotPosterDetailNav = () => import(/* webpackChunkName: "appcenter" */'@/components/appCenter/HotPosterDetailNav')
const BombPoster = () => import(/* webpackChunkName: "appcenter" */'@/components/appCenter/BombPoster')
const DataStatistics = () => import(/* webpackChunkName: "appcenter" */'@/components/appCenter/DataStatistics')
const PosterMateriel = () => import(/* webpackChunkName: "appcenter" */'@/components/appCenter/PosterMateriel')
const DisaccountSet = () => import(/* webpackChunkName: "appcenter" */'@/components/appCenter/DisaccountSet')
const GatherLog = () => import(/* webpackChunkName: "appcenter" */'@/components/appCenter/GatherLog')
const GatherStatistics = () => import(/* webpackChunkName: "appcenter" */'@/components/appCenter/GatherStatistics')
const OpenBillItem = () => import(/* webpackChunkName: "appcenter" */'@/components/appCenter/OpenBillItem')
const OfflineBuyIntro = () => import(/* webpackChunkName: "appcenter" */'@/components/appCenter/OfflineBuyIntro')              // 活动报名开始页面
const ActiveSignUp = () => import(/* webpackChunkName: "appcenter" */'@/components/appCenter/ActiveSignUp')  // 活动报名介绍页面
const ActiveSignUpDetail = () => import(/* webpackChunkName: "appcenter" */'@/components/appCenter/ActiveSignUpDetail')   // 活动报名步骤页面
const ActiveSignUpStep = () => import(/* webpackChunkName: "appcenter" */'@/components/appCenter/ActiveSignUpStep') // 应用中心 - 渠道二维码
const ChannelQRcodeNav = () => import(/* webpackChunkName: "appcenter" */'@/components/appCenter/channelQRcode/ChannelQRcodeNav') // 应用中心 - 渠道二维码 - 编辑
const ChannelQRcodeEdit = () => import(/* webpackChunkName: "appcenter" */'@/components/appCenter/channelQRcode/ChannelQRcodeEdit') // 应用中心 - 渠道二维码数据统计 - 查看明细页面
const ChannelQRcodeDetail = () => import(/* webpackChunkName: "appcenter" */'@/components/appCenter/channelQRcode/ChannelQRcodeDetail')  // 应用中心 - 海报统计
const PosterStatisticsList = () => import(/* webpackChunkName: "appcenter" */'@/components/appCenter/posterStatistics/PosterStatisticsList')  // 应用中心 - 海报统计 此页面为拼团秒杀养护卡的详细页面
const PosterStatisticsDetail = () => import(/* webpackChunkName: "appcenter" */'@/components/appCenter/posterStatistics/PosterStatisticsDetail')  // 应用中心 - 海报统计 此页面为节日门店活动页面
const PosterStatisticsDetailBack = () => import(/* webpackChunkName: "appcenter" */'@/components/appCenter/posterStatistics/PosterStatisticsDetailBack')  // 应用中心 - 海报统计 明细 -> 用户明细
const PosterStatisticsUserDetail = () => import(/* webpackChunkName: "appcenter" */'@/components/appCenter/posterStatistics/PosterStatisticsUserDetail')  // 应用中心 - 广告位管理
const adMgrNav = () => import(/* webpackChunkName: "appcenter" */'@/components/appCenter/adMgr/adMgrNav') // 应用中心 - 广告位管理
const adMgrList = () => import(/* webpackChunkName: "appcenter" */'@/components/appCenter/adMgr/adMgrList') // 应用中心 - 充值有礼  -> 充值记录
const RechargeRecord = () => import(/* webpackChunkName: "appcenter" */'@/components/appCenter/Recharge/RechargeRecord')  // 应用中心 - 充值有礼  -> 余额支付记录
const BalancePayRecord = () => import(/* webpackChunkName: "appcenter" */'@/components/appCenter/Recharge/BalancePayRecord')  // 应用中心 - 充值有礼  -> 充值密码
const RechargePswd = () => import(/* webpackChunkName: "appcenter" */'@/components/appCenter/Recharge/RechargePswd')  // 应用中心 - 充值有礼  -> 忘记密码
const ForgetPswd = () => import(/* webpackChunkName: "appcenter" */'@/components/appCenter/Recharge/ForgetPswd') // 应用中心 - 充值有礼  -> 用户协议
const Agreement = () => import(/* webpackChunkName: "appcenter" */'@/components/appCenter/Recharge/Agreement') // 应用中心 - 壳保养活动  -> 活动列表
const NewActiveList = () => import(/* webpackChunkName: "appcenter" */'@/components/appCenter/newActivity/List')// 应用中心 - 壳保养活动  -> banner列表
const NewActiveBanner = () => import(/* webpackChunkName: "appcenter" */'@/components/appCenter/newActivity/Banner') // 应用中心 - 壳保养活动  -> 报名步骤
const NewStepStatus = () => import(/* webpackChunkName: "appcenter" */'@/components/appCenter/newActivity/StepStatus')
const redEnvelopeManage = () => import(/* webpackChunkName: "appcenter" */'@/components/appCenter/redEnvelope/redEnvelopeManage') // 应用中心 - 企微红包
const redEnvelopeRecharge = () => import(/* webpackChunkName: "appcenter" */'@/components/appCenter/redEnvelope/redEnvelopeRecharge') // 应用中心 - 红包充值
const rechargeAffirm = () => import(/* webpackChunkName: "appcenter" */'@/components/appCenter/redEnvelope/rechargeAffirm') // 应用中心 - 充值确认
const InvitationList = () => import(/* webpackChunkName: "appcenter" */'@/components/appCenter/Invitation/InvitationList') // 应用中心 - 邀新有礼  -> 列表
const InvitationAdd = () => import(/* webpackChunkName: "appcenter" */'@/components/appCenter/Invitation/InvitationAdd') // 应用中心 - 邀新有礼  -> 邀新新建
const InvitationData = () => import(/* webpackChunkName: "appcenter" */'@/components/appCenter/Invitation/InvitationData') // 应用中心 - 邀新有礼  -> 数据
const InvitationDetail = () => import(/* webpackChunkName: "appcenter" */'@/components/appCenter/Invitation/InvitationDetail') // 应用中心 - 邀请有利 -> 邀新明细
export default {
  path: 'appcenter',
  component: AppCenterLayout,
  children: [
    {
      name: 'allApp',
      path: 'allApp',
      component: AllAppPage,
      meta: {
        module: 'appcenter',
        keepAlive: true,
      },
    },
    {
      name: 'agreement',
      path: 'allApp/agreement',
      component: Agreement,
      meta: {
        module: 'appcenter',
      },
    },
    {
      name: 'forgetPswd',
      path: 'allApp/forgetPswd',
      component: ForgetPswd,
      meta: {
        module: 'appcenter',
      },
    },
    {
      name: 'rechargeRecord',
      path: 'allApp/rechargeRecord',
      component: RechargeRecord,
      meta: {
        module: 'appcenter',
      },
    },
    {
      name: 'rechargePswd',
      path: 'allApp/rechargePswd',
      component: RechargePswd,
      meta: {
        module: 'appcenter',
      },
    },
    {
      name: 'balancePayRecord',
      path: 'allApp/balancePayRecord',
      component: BalancePayRecord,
      meta: {
        module: 'appcenter',
      },
    },
    {
      name: 'hotRecommendNav',
      path: 'allApp/hotRecommendNav',
      component: HotRecommendNav,
      children: [
        {
          name: 'spikePosterList',
          path: 'spikePosterList',
          component: SpikePosterList,
          meta: {
            module: 'appcenter',
          },
        },
        {
          path: '/',
          redirect: { name: 'spikePosterList' },
        },
      ],
    },
    {
      name: 'hotPosterDetailNav',
      path: 'allApp/hotPosterDetailNav',
      component: HotPosterDetailNav,
      children: [
        {
          name: 'posterMateriel',
          path: 'posterMateriel',
          component: PosterMateriel,
          meta: {
            module: 'appcenter',
          },
        },
        {
          name: 'dataStatistics',
          path: 'dataStatistics',
          component: DataStatistics,
          meta: {
            module: 'appcenter',
          },
        },
        {
          name: 'bombPoster',
          path: 'bombPoster',
          component: BombPoster,
          meta: {
            module: 'appcenter',
          },
        },
        {
          path: '/',
          redirect: { name: 'posterMateriel' },
        },
      ],
    },
    {
      name: 'hotIntroduce',
      path: 'allApp/hotIntroduce',
      component: HotIntroduce,
      meta: {
        module: 'appcenter',
      },
    },
    {
      name: 'offlineBuyIntro',
      path: 'allApp/offlineBuyIntro',
      component: OfflineBuyIntro,
      meta: {
        module: 'appcenter',
      },
    },
    {
      name: 'propagandaPoster',
      path: 'allApp/propagandaPoster',
      component: PropagandaPoster,
      meta: {
        module: 'appcenter',
      },
    },
    {
      name: 'channelQRcode',
      path: 'allApp/channelQRcodeNav',
      component: ChannelQRcodeNav,
      meta: {
        module: 'appcenter',
        keepAlive: true,
      },
    },
    {
      name: 'channelQRcodeEdit',
      path: 'allApp/channelQRcodeEdit',
      component: ChannelQRcodeEdit,
      meta: {
        module: 'appcenter',
        // keepAlive: true,
      },
    },
    {
      name: 'channelQRcodeDetail',
      path: 'allApp/channelQRcodeDetail',
      component: ChannelQRcodeDetail,
      meta: {
        module: 'appcenter',
        // keepAlive: true,
        isSlibing: true,
      },
    },
    {
      name: 'posterStatistics',
      path: 'allApp/posterStatistics',
      component: PosterStatisticsList,
      meta: {
        module: 'appcenter',
        keepAlive: true,
      },
    },
    {
      name: 'posterStatisticsDetail',
      path: 'allApp/posterStatisticsDetail',
      component: PosterStatisticsDetail,
      meta: {
        module: 'appcenter',
        isSlibing: true,
        // keepAlive: true,
      },
    },
    {
      name: 'posterStatisticsDetailBack',
      path: 'allApp/posterStatisticsDetailBack',
      component: PosterStatisticsDetailBack,
      meta: {
        module: 'appcenter',
        isSlibing: true,
        // keepAlive: true,
      },
    },
    {
      name: 'posterStatisticsUserDetail',
      path: 'allApp/posterStatisticsUserDetail',
      component: PosterStatisticsUserDetail,
      meta: {
        module: 'appcenter',
        // keepAlive: true,
      },
    },
    {
      name: 'posterList',
      path: 'allApp/posterList',
      component: PosterList,
      meta: {
        module: 'appcenter',
      },
    },
    {
      name: 'bill',
      path: 'allApp/bill',
      component: PayIcon,
      meta: {
        module: 'appcenter',
      },
    },
    {
      name: 'disaccountSet',
      path: 'allApp/disaccountSet',
      component: DisaccountSet,
      meta: {
        module: 'appcenter',
      },
    },
    {
      name: 'openBillItem',
      path: 'allApp/openBillItem',
      component: OpenBillItem,
      meta: {
        module: 'appcenter',
      },
    },
    {
      name: 'gatherStatistics',
      path: 'allApp/gatherStatistics',
      component: GatherStatistics,
      meta: {
        module: 'appcenter',
      },
    },
    {
      name: 'gatherLog',
      path: 'allApp/gatherLog',
      component: GatherLog,
      meta: {
        module: 'appcenter',
      },
    },
    {
      name: 'ActiveSignUp',
      path: 'allApp/signup',
      component: ActiveSignUp,
      meta: {
        module: 'appcenter',
      },
    },
    {
      name: 'ActiveSignUpDetail',
      path: 'allApp/signup/info',
      component: ActiveSignUpDetail,
      meta: {
        module: 'appcenter',
      },
    },
    {
      name: 'ActiveSignUpStep',
      path: 'allApp/signup/step',
      component: ActiveSignUpStep,
      meta: {
        module: 'appcenter',
      },
    },
    {
      name: 'adMgrNav',
      path: 'allApp/adMgrNav',
      component: adMgrNav,
      meta: {
        module: 'appcenter',
      },
    },
    {
      name: 'adMgrList',
      path: 'allApp/adMgrList',
      component: adMgrList,
      meta: {
        module: 'appcenter',
      },
    },
    // 壳保养活动列表
    {
      name: 'newActiveList',
      path: 'allApp/NewActiveList',
      component: NewActiveList,
      meta: {
        module: 'appcenter',
      },
    },
    // 壳保养活动banner
    {
      name: 'newActiveBanner',
      path: 'allApp/NewActiveBanner',
      component: NewActiveBanner,
      meta: {
        module: 'appcenter',
      },
    },
    // 壳保养活动StepStatus
    {
      name: 'newStepStatus',
      path: 'allApp/NewStepStatus',
      component: NewStepStatus,
      meta: {
        module: 'appcenter',
      },
    },
    // 企微红包
    {
      name: 'redEnvelopeManage',
      path: 'allApp/redEnvelopeManage',
      component: redEnvelopeManage,
      meta: {
        module: 'appcenter',
      },
    },
    // 红包充值
    {
      name: 'redEnvelopeRecharge',
      path: 'allApp/redEnvelopeRecharge',
      component: redEnvelopeRecharge,
      meta: {
        module: 'appcenter',
      },
    },
    // 充值确认
    {
      name: 'rechargeAffirm',
      path: 'allApp/rechargeAffirm',
      component: rechargeAffirm,
      meta: {
        module: 'appcenter',
      },
    },
    {
      name: 'Invitation',
      path: 'allApp/Invitation',
      component: InvitationList,
      meta: {
        module: 'appcenter',
      },
    },
    {
      name: 'InvitationAdd',
      path: 'allApp/InvitationAdd',
      component: InvitationAdd,
      meta: {
        module: 'appcenter',
      },
    },
    {
      name: 'InvitationData',
      path: 'allApp/InvitationData',
      component: InvitationData,
      meta: {
        module: 'appcenter',
      },
    },
    {
      name: 'InvitationDetail',
      path: 'allApp/InvitationDetail',
      component: InvitationDetail,
      meta: {
        module: 'appcenter',
      },
    },
    {
      path: '/',
      redirect: { name: 'posterList' },
    },
  ],
}



// WEBPACK FOOTER //
// ./src/router/appCenter.js